import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../api';
import { Response } from '../genericInterface';
import { ISharesRequest, ISharesRequestStats } from './interface';
import { paginatedResponse } from '../paginatedInterface';

export const sharesRequestApi = createApi({
    reducerPath: 'sharesRequestApi',
    baseQuery: baseQuery,
    tagTypes: ['sharesRequest'],
    endpoints: (builder) => ({
        getAllSharesRequest: builder.query<
            paginatedResponse<ISharesRequest[]>,
            { perPage: number; currentPage: number }
        >({
            query: ({ perPage, currentPage }) => ({
                url: `/loan/api/v1/shares-request?perPage=${perPage}&currentPage=${currentPage}`,
                method: 'GET',
            }),
            providesTags: ['sharesRequest'],
        }),
        deleteSharesRequest: builder.mutation<Response<ISharesRequest>, string>(
            {
                query: (sharesId) => ({
                    url: `/loan/api/v1/shares-request/${sharesId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['sharesRequest'],
            },
        ),
        getSingleSharesRequest: builder.query<Response<ISharesRequest>, string>(
            {
                query: (sharesId) => ({
                    url: `/loan/api/v1/shares-request/${sharesId}`,
                    method: 'GET',
                }),
            },
        ),
        sharesRequestStats: builder.query<Response<ISharesRequestStats>, void>({
            query: () => ({
                url: `/loan/api/v1/shares-request/a/stats`,
                method: 'GET',
            }),
            providesTags: ['sharesRequest'],
        }),
        updateSharesRequest: builder.mutation<
            Response<ISharesRequest>,
            {
                requestStatus: string;
                authorizedBy: string | null;
                sharesRequestId: string;
            }
        >({
            query: ({ requestStatus, authorizedBy, sharesRequestId }) => ({
                url: `/loan/api/v1/shares-request/manage-shares-request/${sharesRequestId}`,
                method: 'PUT',
                body: { requestStatus, authorizedBy },
            }),
            invalidatesTags: ['sharesRequest'],
        }),
    }),
});

export const {
    useGetAllSharesRequestQuery,
    useGetSingleSharesRequestQuery,
    useDeleteSharesRequestMutation,
    useSharesRequestStatsQuery,
    useUpdateSharesRequestMutation,
} = sharesRequestApi;
